import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, IconButton, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SettingsIcon from '@mui/icons-material/Settings';

const HeaderSection = ({ projectName, fieldId, onBack, showSettings = true }) => {
    const navigate = useNavigate();
    const { projectId } = useParams();

    const handleSettings = () => {
        navigate(`/projects/${projectId}/settings`);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2.5,
                width: '100%',
                px: 0.5,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                    onClick={onBack}
                    sx={{
                        mr: 1,
                        color: '#5b616e',
                        p: 0.75,
                        '&:hover': {
                            backgroundColor: 'rgba(17, 51, 83, 0.02)',
                        },
                    }}
                    size="small"
                >
                    <ArrowBackIcon fontSize="small" />
                </IconButton>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography
                        component="h1"
                        sx={{
                            fontWeight: 600,
                            color: '#0a0b0d',
                            fontSize: '1.3rem',
                            letterSpacing: '-0.01em',
                        }}
                    >
                        {projectName}
                    </Typography>
                    {fieldId && (
                        <Chip
                            label={fieldId}
                            size="small"
                            variant="outlined"
                            sx={{
                                fontSize: '0.75rem',
                                height: '24px',
                                borderColor: '#e0e0e0',
                                color: '#666',
                                backgroundColor: '#f8f9fa',
                            }}
                        />
                    )}
                </Box>
            </Box>

            {showSettings && (
                <IconButton
                    onClick={handleSettings}
                    sx={{
                        color: '#5b616e',
                        p: 1,
                        width: 40,
                        height: 40,
                        '&:hover': {
                            backgroundColor: 'rgba(17, 51, 83, 0.02)',
                        },
                    }}
                    aria-label="settings"
                >
                    <SettingsIcon sx={{ fontSize: 24 }} />
                </IconButton>
            )}
        </Box>
    );
};

export default HeaderSection;
